/**
 *
 * @returns {string}
 */
const admin = () => 'admin';

/**
 * @returns {string}
 */
export const adminTeams = () => `${admin()}/teams`;

/**
 * @returns {string}
 */
const adminTeam = (teamUuid) => `${adminTeams()}/${teamUuid}`;

/**
 * @returns {string}
 */
export const adminTeamPayments = (teamUuid) =>
  `${adminTeam(teamUuid)}/payments`;

/**
 * @returns {string}
 */
export const adminAppPciMode = (teamUuid, appUuid) =>
  `${adminTeam(teamUuid)}/apps/${appUuid}/pci-mode`;

/**
 * @returns {string}
 */
export const adminAppMerchants = (teamUuid, appUuid) =>
  `${adminTeam(teamUuid)}/apps/${appUuid}/payments/merchants`;

/**
 * @returns {string}
 */
export const adminAppMerchant = (teamUuid, appUuid, merchantUuid) =>
  `${adminAppMerchants(teamUuid, appUuid)}/${merchantUuid}`;

/**
 * @returns {string}
 */
export const adminAppMerchantAddress = (teamUuid, appUuid, merchantUuid) =>
  `${adminAppMerchant(teamUuid, appUuid, merchantUuid)}/address`;

/**
 * @returns {string}
 */
export const adminAppRelays = (teamUuid, appUuid) =>
  `${adminTeam(teamUuid)}/apps/${appUuid}/relays`;

/**
 * @returns {string}
 */
export const adminAppRelayCustomExtensions = (teamUuid, appUuid, relayUuid) =>
  `${adminAppRelays(teamUuid, appUuid)}/${relayUuid}/custom-extensions`;

/**
 * @returns {string}
 */
export const adminTeamEnclaveLimits = (teamUuid) =>
  `${adminTeam(teamUuid)}/enclaves/limits`;

/**
 * @returns {string}
 */
export const adminTeamEnclaveInfo = (teamUuid) =>
  `${adminTeam(teamUuid)}/enclaves`;

/**
 * @returns {string}
 */
export const adminTeamEnclaveDisable = (teamUuid, enclaveUuid) =>
  `${adminTeamEnclaveInfo(teamUuid)}/${enclaveUuid}/disable`;

export const adminTeamResourceUsageLimits = (teamUuid) =>
  `${adminTeam(teamUuid)}/resource-usage-limits`;
